<template>
  <div class="flex flex-col gap-3">
    <PaginatedList
      :load="load"
      :query-key="queryKey"
      :empty-text="emptyText ?? t('noBookingFound')"
    >
      <template #entry="{ entry }">
        <BookingListItem :booking="entry" :show-menu="showMenu" />
      </template>
    </PaginatedList>
  </div>
</template>

<script lang="ts" setup>
import PaginatedList from '@/components/PaginatedList.vue';
import BookingListItem from './BookingListItem.vue';
import { bookingsService } from '@/api/bookings.service';
import { BOOKINGS_QUERY_KEY } from '@/queries/use-bookings';
import type { FindAllBookingsQueryDto } from '@/entities/bookings/booking.entity';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = withDefaults(
  defineProps<{
    query: FindAllBookingsQueryDto;
    emptyText?: string;
    showMenu?: boolean;
  }>(),
  { showMenu: true },
);

const { t } = useI18n();
const queryKey = computed(() => [BOOKINGS_QUERY_KEY, props.query]);
const load = (page: number) => bookingsService.getAllWithQuery({ ...props.query, page });
</script>

<i18n lang="json">
{
  "en": {
    "noBookingFound": "No Bookings found"
  },
  "de": {
    "noBookingFound": "Es wurden keine Buchungen gefunden"
  },
  "es": {
    "noBookingFound": "No se encontraron reservas"
  }
}
</i18n>
